import React, { useContext, useEffect, useState } from "react";

import ExportComponents from "../../../Components/ExportComponents";
import Account from "../../../Services/accountServices";
import USDFigure from "../../../Components/USDFigure";
import { baseUrl } from "../../../config/EnVariables";
import { AuthContext } from "../../../Auth/Context/AuthContext";
import AFNFigure from "../../../Components/AFNFigure";
import TitleHeader from "../Components/TitleHeader";
function GenralJournel(props) {
  const { accounts } = useContext(AuthContext);
  const [downloadableData, setDownloadableData] = useState([]);
  const [startDate, setStartDate] = useState(
    `${new Date().getFullYear()}-${new Date().getMonth() + 1}-01`
  );
  const [endDate, setEndDate] = useState(
    `${new Date().getFullYear()}-${
      new Date().getMonth() + 1
    }-${new Date().getDate()}`
  );
  const [journals, setJournals] = useState([]);

  const fetchJournals = async () => {
    let data = {
      startDate: startDate,
      endDate: endDate,
    };

    await Account.getJournals(data).then((jls) => {
      const jours = jls.data.map((journal) => {
        console.log("JOUrenals", jls.data);
        const filteredLines = journal.lines.filter((line) => {
          const accountName = line.accountName || "";
          return !accountName.includes("Position Account");
        });

        return { ...journal, lines: filteredLines };
      });
      const downloadingData = jours.map((item) =>
        item.lines.map((line) => ({
          transactionID: item.name,
          date: line.date,
          account: line.accountName,
          memo: line.note,
          debit: line.debit,
          credit: line.credit,
        }))
      );
      let arr = [];
      for (let i = 0; i < downloadingData.length; i++) {
        for (let j = 0; j < downloadingData[i].length; j++) {
          arr.push(downloadingData[i][j]);
        }
      }
      setDownloadableData(arr);
      setJournals(jours);
    });
  };
  useEffect(() => {
    fetchJournals();
  }, []);
  const filter = () => {
    console.log("START DATE:", startDate);
    console.log("END DATE:", endDate);
    fetchJournals();
  };

  return (
    <div class="page-wrapper">
      <div class="content container-fluid">
        <TitleHeader title="Genral Journel" />
        <div class="row">
          <div class="col-sm-12">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ display: "flex" }}>
                <div>
                  Start Date
                  <input
                    className="form-control "
                    type="date"
                    value={startDate}
                    name="start_date"
                    onChange={(val) => setStartDate(val.target.value)}
                  />
                </div>
                <div>
                  End Date
                  <input
                    className="form-control "
                    type="date"
                    value={endDate}
                    name="end_date"
                    onChange={(val) => setEndDate(val.target.value)}
                  />
                </div>
                <div>
                  <br />
                  <a href="#" className="btn btn-secondary" onClick={filter}>
                    <i class="ion-ios7-search-strong"></i> Search
                  </a>
                </div>
              </div>
              <ExportComponents
                excelData={downloadableData}
                fileName={endDate + "Journals.xlsx"}
              />
            </div>
            <div class="card">
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>
                          <i
                            class="ion-link"
                            data-bs-toggle="tooltip"
                            title="Attachment"
                          ></i>
                        </th>
                        <th>Transaction</th>
                        <th>Account</th>
                        <th>Date</th>
                        <th>Memo</th>
                        <th>Debit</th>
                        <th>Credit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {journals.map((item) => {
                        return (
                          <>
                            {item.lines.map((line) => (
                              <tr>
                                {item.attachment || item.attachmentName ? (
                                  <th>
                                    <a
                                      href={`${baseUrl}/download?fileName=${item.attachmentName}&entity=general%20journal`}
                                      target="_blank"
                                    >
                                      <i
                                        class="ion-link"
                                        data-bs-toggle="tooltip"
                                        title="Attachment"
                                      ></i>
                                    </a>
                                  </th>
                                ) : (
                                  <th></th>
                                )}
                                <th>{item.name}</th>
                                <th>{line.accountName}</th>
                                <th>{line.date}</th>
                                <th>{item.note}</th>
                                <th>
                                  {line.accountName?.includes("AFN") ? (
                                    <AFNFigure amount={line.debit} />
                                  ) : (
                                    <USDFigure amount={line.debit} />
                                  )}
                                </th>
                                <th>
                                  {line.accountName?.includes("AFN") ? (
                                    <AFNFigure amount={line.credit} />
                                  ) : (
                                    <USDFigure amount={line.credit} />
                                  )}
                                </th>
                              </tr>
                            ))}
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GenralJournel;
